module.exports = __webpack_public_path__ + "img/headlogo.f4e48780.png";